import { HStack, Text, VStack } from '@chakra-ui/react';

import { usePluralisationTranslation } from '@nocowanie/common-ui/hooks';
import { IconsLinear } from '@nocowanie/icons/linear';

import { RoomPictogramsProps } from './room-pictograms.props';

export const RoomPictograms = ({
    size,
    singleBeds,
    doubleBeds,
    iconSize = 'md',
    ...props
}: RoomPictogramsProps) => {
    const pluralizeTranslation = usePluralisationTranslation('accommodation', 'bedType');

    const singleBedLabel = singleBeds ? pluralizeTranslation(singleBeds, 'single') : undefined;
    const doubleBedLabel = doubleBeds ? pluralizeTranslation(doubleBeds, 'double') : undefined;

    return (
        <VStack align={'flex-start'} {...props}>
            {size && (
                <HStack align={'flex-end'}>
                    <IconsLinear.RoomSize size={iconSize} />{' '}
                    <Text as={'span'} lineHeight={'1'} fontSize={'sm'}>
                        {size} m<sup>2</sup>
                    </Text>
                </HStack>
            )}
            {singleBedLabel && (
                <HStack align={'flex-end'}>
                    <IconsLinear.SingleBed size={iconSize} />{' '}
                    <Text as={'span'} lineHeight={'1'} fontSize={'sm'}>
                        {singleBedLabel}
                    </Text>
                </HStack>
            )}
            {doubleBedLabel && (
                <HStack align={'flex-end'}>
                    <IconsLinear.DoubleBed size={iconSize} />{' '}
                    <Text as={'span'} lineHeight={'1'} fontSize={'sm'}>
                        {doubleBedLabel}
                    </Text>
                </HStack>
            )}
        </VStack>
    );
};
